import { useTranslation } from 'react-i18next';

import { Mascot } from './Mascot';

/**
 * 설문이 끝났다고 알리는 화면 (시안 `758:20959`).
 *
 * 설문 8단계와 진단 사이의 **쉼표**다. 여기가 없으면 마지막 선택지를 고른 손가락이
 * 곧바로 진단 안내로 넘어가, 답을 다 냈다는 신호를 아무도 안 준다. 시안이 이 자리에만
 * 마스코트를 크게 쓰는 것도 같은 이유로 읽힌다.
 *
 * 진행 바는 셸이 계속 그린다 — 시안은 이 화면에서 진행 바를 빼지만, 웹의 단계 수가
 * 시안(8)과 달라(설문 뒤로 진단·결과·로그인이 이어진다) 여기서 바를 감추면 다음
 * 화면에서 다시 나타나 "끝났다가 아니었다"로 읽힌다.
 */
export const SurveyDoneStep = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col items-center">
      <h2 className="mt-16 whitespace-pre-line text-center text-[22px] font-semibold leading-[1.5] tracking-[-0.11px] text-[hsl(var(--title))]">
        {t('web.onboarding.surveyDone.title')}
      </h2>

      {/* 캡슐 배너 — 설문의 사각 배너와 달리 테두리만 있는 알약이다(시안).
          다음에 무엇을 하는지 한 줄로 예고하는 자리라 경고처럼 보이면 안 된다. */}
      <p className="mt-6 rounded-full border border-primary/30 bg-[hsl(var(--surface-lowest))] px-5 py-3 text-center text-sm font-medium text-foreground">
        {t('web.onboarding.surveyDone.banner')}
      </p>

      <Mascot className="mt-10 w-[180px]" />
    </div>
  );
};
